import React from 'react';
import { Link, usePage } from '@inertiajs/react';
import { useTrans } from '../../../hooks/useTrans';
import { User, Mail, Lock, ShieldCheck } from 'lucide-react';

const tabIcons = {
    '/profiel': <User className="h-5 w-5" />,
    '/profiel/email': <Mail className="h-5 w-5" />,
    '/profiel/wachtwoord': <Lock className="h-5 w-5" />,
    '/profiel/beveiliging': <ShieldCheck className="h-5 w-5" />,
};

export default function ProfileTabs() {
    const translate = useTrans();
    const { routes } = usePage().props;
    const currentUrl = usePage().url;

    const tabs = [
        { label: translate('Profiel & notificaties'), href: routes.profileEdit, match: '/profiel' },
        { label: translate('E-mailadres'), href: routes.profileEmail, match: '/profiel/email' },
        { label: translate('Wachtwoord'), href: routes.profilePassword, match: '/profiel/wachtwoord' },
        { label: translate('Beveiliging'), href: routes.profileSecurity, match: '/profiel/beveiliging' },
    ];

    function isActive(tab) {
        return currentUrl === tab.match || currentUrl.startsWith(tab.match + '?');
    }

    return (
        <div className="flex items-end gap-[5px]">
            {tabs.map((tab) => (
                <Link
                    key={tab.match}
                    href={tab.href}
                    title={tab.label}
                    className={`flex items-center justify-center flex-1 sm:flex-none px-3 py-2 sm:px-[15px] sm:py-[10px] font-bold text-[#003545] no-underline sm:text-lg transition-transform ${
                        isActive(tab)
                            ? 'bg-white border border-[#bbb] border-b-white rounded-t-[5px] -mb-px'
                            : 'border border-transparent hover:bg-white/40 hover:border-[#bbb] hover:border-b-transparent hover:rounded-t-[5px] sm:hover:-translate-y-[5px] sm:hover:pb-[15px] sm:hover:-mb-[5px]'
                    }`}
                >
                    <span className="sm:hidden">{tabIcons[tab.match]}</span>
                    <span className="hidden sm:inline">{tab.label}</span>
                </Link>
            ))}
        </div>
    );
}
